import { useState } from "react";
import { cn } from "@/lib/utils";
import { isVideoMediaUrl } from "@/lib/mediaUrl";

/** Photo or video thumb — video shows muted preview + Video chip. */
export function MediaThumb({
  url,
  className,
  videoClassName,
}: {
  url: string;
  className?: string;
  videoClassName?: string;
}) {
  const [missing, setMissing] = useState(false);
  if (isVideoMediaUrl(url)) {
    return (
      <div className={cn("relative h-full w-full overflow-hidden bg-black", className)}>
        <video
          src={url}
          className={cn("h-full w-full object-cover", videoClassName)}
          muted
          playsInline
          preload="metadata"
        />
        <div className="absolute bottom-1 right-1 rounded bg-black/60 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-white">
          Video
        </div>
      </div>
    );
  }
  // Slice 56: a photo still on the cleaner's phone has no picture here yet; it fills in by itself.
  if (missing) {
    return (
      <div
        className={cn(
          "flex h-full w-full items-center justify-center border-[1.5px] border-dashed border-[#cdd8df] bg-[#f4f7f9] px-1 text-center text-[10.5px] font-bold leading-tight text-[#8494a2]",
          className,
        )}
      >
        still on phone
      </div>
    );
  }
  return (
    <img
      src={url}
      alt=""
      className={cn("h-full w-full object-cover", className)}
      onError={() => {
        setMissing(true);
        window.setTimeout(() => setMissing(false), 10_000);
      }}
    />
  );
}
